import { isEmpty } from 'lodash';

export const redirectToSearchUrl = searchQuery => {
  const { searchPageUrl } = window.inlineSearchConfiguration;
  const query = searchQuery.replace('#', '-');
  return `${window.location.origin}${searchPageUrl}?query=${encodeURIComponent(query)}&referrer=searchBar`;
};

export const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const buildSuggestionUrl = (suggestionUrl, searchQuery) => {
  const constructUrl = new URL(suggestionUrl, window.location.origin);
  const hasSearchQuery = constructUrl.searchParams.get('query');
  const hashParam = constructUrl.hash || '';
  const isEmptySearchQuery = isEmpty(constructUrl.search);
  const productUrl = `${constructUrl.origin}${constructUrl.pathname}`;
  const queryParam = `${isEmptySearchQuery ? '?' : '&'}query=${
    isEmpty(searchQuery) ? 'no%20query' : `${encodeURIComponent(searchQuery)}`
  }`;

  return hasSearchQuery ? suggestionUrl : `${productUrl}${queryParam}${hashParam}`;
};
